import { render, staticRenderFns } from "./editorTop.vue?vue&type=template&id=58fd33bc&scoped=true&"
import script from "./editorTop.vue?vue&type=script&lang=js&"
export * from "./editorTop.vue?vue&type=script&lang=js&"
import style0 from "./editorTop.vue?vue&type=style&index=0&id=58fd33bc&lang=less&scoped=true&"
import style1 from "./editorTop.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fd33bc",
  null
  
)

export default component.exports